import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ProportionalIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Falloff/gradient circle - concentric rings showing proportional influence */}
      {/* Outer ring (faint) */}
      <circle cx="12" cy="12" r="10" stroke={color} strokeWidth={strokeWidth} fill="none" opacity="0.3" />
      {/* Middle ring (medium) */}
      <circle cx="12" cy="12" r="6" stroke={color} strokeWidth={strokeWidth} fill="none" opacity="0.6" />
      {/* Inner circle (solid) */}
      <circle cx="12" cy="12" r="2.5" fill={color} />
    </BaseIcon>
  ),
);

ProportionalIcon.displayName = 'ProportionalIcon';
